export const t = {
    title: "Verlanglijst",
    waiting: "...bezig",
    edit: "Aanpassen",
    add: "Toevoegen",
    delete: "Verwijderen",
    confirmDelete: "Weet je zeker dat je dit item wilt verwijderen?",
    name: "Naam",
    price: "Prijs",
    claimable: "Afstreepbaar",
    claimed: "Afgestreept",
    claim: "Streep af",
    unclaim: "Niet meer afstrepen",
    url: "Link",
    image: "Afbeelding link",
    login: "Log in",
    logout: "Log uit",
    loginError: "Verkeerde gebruikersnaam of wachtwoord",
    username: "Gebruikersnaam",
    password: "Wachtwoord",
    yourMail: "Je mail adres (optioneel)",
    mailDisclaimer: "Je mail adres opgevenis niet verplicht. Het wordt alleen gebruikt om 1 mail te versturen met een link om het afstrepen ongedaan te maken en zal niet worden opgeslagen."
}